import { useQuery, useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import * as api from "apis/tenants";

//Query untuk get all tenants
export function useTenants(options = {}) {
  const { t } = useTranslation();
  return useQuery(
    ["tenants"],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getTenants();
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

//Query untuk get tenant field data
export function useTenantFieldData(options = {}) {
  const { t } = useTranslation();
  return useQuery(
    ["tenants/fieldData"],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getTenantFieldData();
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

//Query untuk check tenant
export function useCheckTenant(payload = {}, options = {}) {
  const { t } = useTranslation();
  return useQuery(
    ["checkTenant", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.checkTenant(payload?.name);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

// Query untuk register company
export const useRegisterCompany = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.registerCompany(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message || t("error.failed_save_data_to_server"));
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk register tenant
export const useRegisterTenant = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.registerTenant(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk delete tenant
export const useDeleteTenant = () => {
  const { t } = useTranslation();
  return useMutation((id) => api.deleteTenant(id), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};
